import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getRequest } from "../../apis/ApiInstence";

const buildOptions = (title, rows) => ({
  chart: { type: "column" },
  title: { text: title },
  xAxis: { categories: rows.map((r) => r.item_name) },
  yAxis: [
    { min: 0, title: { text: "Quantity Purchased" } },
    { min: 0, title: { text: "Revenue (₹)" }, opposite: true }
  ],
  series: [
    { name: "Quantity", type: "column", yAxis: 0, data: rows.map((r) => Number(r.qty)) },
    { name: "Revenue (₹)", type: "spline", yAxis: 1, data: rows.map((r) => Number(r.revenue)) }
  ]
});

const ChemicalMachineSalesChart = () => {
  const [chemicals, setChemicals] = useState([]);
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    getRequest("dashboard/chemical-machine-sales").then((res) => {
      setChemicals(res?.data?.chemicals || []);
      setMachines(res?.data?.machines || []);
    });
  }, []);

  return (
    <div className="row">
      <div className="col-lg-6 mb-4">
        <HighchartsReact highcharts={Highcharts} options={buildOptions("Top Chemicals (Qty & Revenue)", chemicals)} />
      </div>
      <div className="col-lg-6 mb-4">
        <HighchartsReact highcharts={Highcharts} options={buildOptions("Top Machines (Qty & Revenue)", machines)} />
      </div>
    </div>
  );
};

export default ChemicalMachineSalesChart;
